import { render, staticRenderFns } from "./BaseListingHandler.vue?vue&type=template&id=453d9e0b&"
import script from "./BaseListingHandler.vue?vue&type=script&lang=js&"
export * from "./BaseListingHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports